import React from 'react'
import { SVGIconProps } from '../types'
const SvgPlaylistAddCheck = ({ size = 16, ...props }: SVGIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
    {...props}
  >
    <path fill="none" d="M0 0h24v24H0z" />
    <path d="M14 10H2v2h12zm0-4H2v2h12zM2 16h8v-2H2zm19.5-4.5L23 13l-6.99 7-4.51-4.5L13 14l3.01 3z" />
  </svg>
)
export default SvgPlaylistAddCheck
